import FormLinkDescription from '@/forms/components/FormLinkDescription';
import fieldComponents from './helper';
import RequestLinkList from './components/RequestLinkList';
import RequestObjectList from './components/RequestObjectList';
import RequestObjectDescription from './components/RequestObjectDescription';

export default {
  ...fieldComponents,
  link: { editor: RequestLinkList, component: FormLinkDescription, hasLabel: true },
  object: { editor: RequestObjectList, component: RequestObjectDescription, hasLabel: true },
};
